export default {
  path: '/work-queue',
  component: () => import('@/views/work-queue/work-queue'),
}
